<template>
  <div class="card-box">
    <div
      class="card-box-item"
      v-for="(item, index) in bagList"
      :key="index"
      @click="goTodDetails(item.packageId)"
    >
      <div class="item-bg">
        <img :src="item.backgroundImage" />
      </div>
      <div class="item-text">
        <div
          class="text-top"
          :style="{
            color:
              item.fontColor == 'black'
                ? 'rgba(0,0,0,0.95)'
                : 'rgba(255,255,255,0.95)',
          }"
        >
          {{ item.name }}
        </div>
        <div
          class="text-center"
          :style="{
            color:
              item.fontColor == 'black'
                ? 'rgba(0,0,0,0.7)'
                : 'rgba(255,255,255,0.7)',
          }"
        >
          {{ item.description }}
        </div>
        <div
          class="text-bottom"
          :style="{
            color:
              item.fontColor == 'black'
                ? 'rgba(0,0,0,0.7)'
                : 'rgba(255,255,255,0.7)',
          }"
        >
          有效期{{ item.expiredTime }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    activityId: {
      type: String,
      default: '',
    },
    shareId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      bagList: [],
    }
  },
  computed: {},
  mounted() {
    this.getCardBagList()
  },
  methods: {
    // 获取卡包list
    getCardBagList() {
      this.$http
        .get(`aocampaign/openapi/coupon/package/list/${this.activityId}`)
        .then((res) => {
          if (!res.data) {
            return false
          }
          res.data.forEach((item) => {
            item.expiredTime = this.moment(item.expiredTime).format(
              'YYYY-MM-DD'
            )
          })
          this.bagList = res.data
        })
    },
    goTodDetails(id) {
      this.$router.push(`cardBagDetail?id=${id}&shareId=${this.shareId}`)
      // uni.navigateTo({
      //   url: `/cardBag/cardBagDetail?id=${id}`,
      // })
    },
  },
}
</script>

<style lang="less" scoped>
.card-box {
  margin: 8px 0;
}
.card-box-item {
  position: relative;
  width: 100%;
  height: 130px;
  background: red;
  margin-top: 8px;
  z-index: 0;
}
.card-box-item:first-child {
  margin-top: 0;
}
.item-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
  img {
    width: 100%;
    height: 100%;
  }
}
.item-text {
  position: relative;
  width: 230px;
  color: #fff;
  padding: 16px;
  z-index: 20;
  .text-top {
    height: 28px;
    line-height: 28px;
    font-weight: 600;
    font-size: 20px;
  }
  .text-center,
  .text-bottom {
    margin-top: 4px;
    height: 14px;
    line-height: 14px;
    font-size: 10px;
  }
  .text-top,
  .text-center,
  .text-bottom {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
